import { isRequired } from 'utils/validators';

const validate =(values) => { 
  const errors = {};

  if (values.payments && values.payments.length) {
    const payments = values.payments;
    const paymentsArrayErrors = [];

    payments.forEach((item, index) => {
      const paymentsErrors = {};
      const isUpdate = item.isCreated;
      if (item.paymentSystem === 'PayPal') {
        if (isRequired(item.clientId, true)) {
          paymentsErrors['clientId'] = 'Client ID is required';
          paymentsArrayErrors[index] = paymentsErrors;
        }

        if (isRequired(item.clientSecret || '', true)) {
          paymentsErrors['clientSecret'] = 'Client secret is required';
          paymentsArrayErrors[index] = paymentsErrors;
        }
      } else if (item.paymentSystem === 'Stripe') {
        if (isRequired(item.publishableKey, true)) {
          paymentsErrors['publishableKey'] = 'Publishable key is required';
          paymentsArrayErrors[index] = paymentsErrors;
        }

        if (!isUpdate && (isRequired(item.secretKey || '', true) || (item.secretKey && item.secretKey.trim() === ''))) {
          paymentsErrors['secretKey'] = 'API password is required and cannot be empty or contain only spaces';
          paymentsArrayErrors[index] = paymentsErrors;
        } 
        else if (!isUpdate && item.secretKey) {
         
          item.secretKey = item.secretKey.trim();
        }
      }
    });
    if (paymentsArrayErrors.length) {
      errors.payments = paymentsArrayErrors;
      errors.payments = {
        ...paymentsArrayErrors,
        _error: { ...paymentsArrayErrors }
      };
    }
  }

  return errors;
};

export default validate;
